import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { Group } from "@/app/services/generated/groupService";
import { groupService } from "@/app/services/generated/groupService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasGroupsCache {
  groups: GroupsCache;
}

// Singleton cache store
const groupsCacheStore = new EntityCacheStore<Group>(
  EnumCacheEntityType.group,
  async () => groupService.getAllGroups()
);

// Ephemeral reader
export default class GroupsCache extends EntityWithGuidKeyCache<Group> {
  constructor() {
    super(groupsCacheStore, (x) => x.id);
  }
}
